import React from "react";

export default function BlockedUser() {
  return (
    <div className="container">
      <div className="starter-template text-center mt-5">
        <h1>Perfil desactivado</h1>
        <p className="lead">
          Su perfil está desactivado, por favor contactar al administrador
          <a
            href="http://www.ibrahim.com.co/"
            class="nav-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ibrahim Consumer Behavior
          </a>
        </p>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/User/BlockedUser.js